<template>
	<div class="bg-slider">
		<!--<img v-for="image in imglist" :key="image" :src="image" alt="" @load="loaded($event)" @error="error($event)">-->
	</div>
</template>
<script>
	export default {
		props: ['imglist'],
		// created() {
		// 	console.log("bg-slider created > ", this.imglist);
		// },
		methods: {
			loaded(e) {
				console.log("image loaded >> ", e)
			},
			error(e) {
				console.log("image error >> ", e);
			}

		}
	}
</script>
<style lang="stylus">
@import '~settings'
@import '~rupture'
.bg-slider
	background-color rgb(249, 249, 249)
	position absolute 0 0 0 0
	transform none
	width 100vw
	height 100%
	overflow hidden
	z-index -1
	//opacity 0.75
	&:after
	// &:before
		position absolute 0 0 0 0
		width 100%
		height 100%
		content ''
		//background url(/img/dark-net-overlay.png) repeat 0 0
		z-index 9
	// &:before
	// 	background #121212
	// 	z-index 8
	// 	opacity 0.65

	img
		self-center()
		min-width 100%
		min-height 100%
		&:first-child
			z-index 9
		+portrait()
			width auto
			height 100%
			position absolute
			left 50%
			top 0
			transform translateX(-50%)
</style>
